import { AlertTriangle, TrendingUp, CheckCircle2, X } from "lucide-react";

const TriadCard = ({ icon: Icon, tone, title, points, testid }) => (
  <div data-testid={testid} className={`rounded-2xl border p-6 sm:p-8 ${tone.box}`}>
    <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-5 ${tone.iconBox}`}>
      <Icon className={`w-5 h-5 ${tone.icon}`} />
    </div>
    <h3 className="text-xl sm:text-2xl font-black font-['Cabinet_Grotesk'] text-white mb-4">{title}</h3>
    <ul className="space-y-3">
      {points.map((p) => (
        <li key={p} className="flex gap-3 text-sm sm:text-base text-white/80 leading-relaxed">
          <span className={`mt-2 w-1.5 h-1.5 rounded-full shrink-0 ${tone.dot}`} />
          {p}
        </li>
      ))}
    </ul>
  </div>
);

const MustHaveTable = ({ title, rows }) => (
  <div data-testid="sales-triad-must" className="rounded-2xl border border-[#a855f7]/40 bg-[#a855f7]/5 p-6 sm:p-8">
    <h3 className="text-xl sm:text-2xl font-black font-['Cabinet_Grotesk'] text-white mb-5">{title}</h3>
    <div className="overflow-x-auto">
      <table className="w-full text-sm sm:text-base min-w-[520px]">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wider text-white/50 font-['JetBrains_Mono']">
            <th className="pb-3 pr-4 font-normal"></th>
            <th className="pb-3 pr-4 font-normal">Bez nás</th>
            <th className="pb-3 font-normal text-[#c084fc]">S TopRankPulse</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(([label, without, withUs]) => (
            <tr key={label} className="border-t border-white/10">
              <td className="py-3 pr-4 font-bold text-white">{label}</td>
              <td className="py-3 pr-4 text-white/60"><X className="w-4 h-4 inline mr-1.5 text-red-400" />{without}</td>
              <td className="py-3 text-white"><CheckCircle2 className="w-4 h-4 inline mr-1.5 text-emerald-400" />{withUs}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const FEAR = { box: "border-red-500/25 bg-red-500/5", iconBox: "bg-red-500/15", icon: "text-red-400", dot: "bg-red-400" };
const HOPE = { box: "border-emerald-500/25 bg-emerald-500/5", iconBox: "bg-emerald-500/15", icon: "text-emerald-400", dot: "bg-emerald-400" };

// Fear → Hope → Must-have sales structure, placed between hero and details.
export const SalesTriadSection = ({ fear, hope, must, testid = "sales-triad" }) => (
  <section data-testid={testid} className="max-w-6xl mx-auto px-5 sm:px-8 py-16 sm:py-24 space-y-6">
    <div className="grid md:grid-cols-2 gap-6">
      <TriadCard icon={AlertTriangle} tone={FEAR} title={fear.title} points={fear.points} testid={`${testid}-fear`} />
      <TriadCard icon={TrendingUp} tone={HOPE} title={hope.title} points={hope.points} testid={`${testid}-hope`} />
    </div>
    <MustHaveTable title={must.title} rows={must.rows} />
  </section>
);

export default SalesTriadSection;
